export const TAGS_WHITELIST: string[] = ['ol', 'li', 'br', 'ul', 'p', 'span']
